import { IMBISS_BIS, IMBISS_HALBBREITE, IMBISS_VON, IMBISSE_GERADE_X, IMBISSE_WINKEL_OST_GRAD, IMBISSE_WINKEL_WEST_GRAD, MARATHONTOR_TUERME_GRAD, TORE_GERADE_X, TORE_WINKEL_OST_GRAD, TORE_WINKEL_WEST_GRAD, TURM, } from './masse.js';
import { achsen, lageZurAchse } from './oval.js';
/** Die dreizehn Torachsen: Tunnel zur Promenade, daneben je ein Treppenturm. */
export const TORE = achsen(TORE_WINKEL_OST_GRAD, TORE_WINKEL_WEST_GRAD, TORE_GERADE_X);
/**
 * Jeder Turm steht in Umlaufrichtung neben seinem Tor; dazu die beiden
 * Tuerme am Marathontor, die den Sektor noerdlich der Plattform erschliessen
 * (und suedlich das Bild spiegeln).
 */
export const TUERME = [
    // Am westlichen Tor bei −34° steht der Turm auf der anderen Seite: den
    // Sektor zur Plattform hin erschliesst der Marathontor-Turm, und so bleibt
    // Platz fuer den Imbiss dazwischen.
    ...TORE.map((achse) => ({
        achse,
        seite: achse.typ === 'kurve' && !achse.ost && achse.grad === -34 ? -1 : 1,
    })),
    { achse: { typ: 'kurve', ost: false, grad: MARATHONTOR_TUERME_GRAD }, seite: 1 },
    { achse: { typ: 'kurve', ost: false, grad: -MARATHONTOR_TUERME_GRAD }, seite: -1 },
];
export const TUERME_ANZAHL = TUERME.length;
const IMBISSE = achsen(IMBISSE_WINKEL_OST_GRAD, IMBISSE_WINKEL_WEST_GRAD, IMBISSE_GERADE_X);
export const IMBISSE_ANZAHL = IMBISSE.length;
/** Kleinster Querabstand zu einer Torachse — Infinity, wenn keine zustaendig ist. */
export function abstandZumTor(px, py) {
    let bester = Infinity;
    for (const achse of TORE) {
        const lage = lageZurAchse(px, py, achse);
        if (lage)
            bester = Math.min(bester, Math.abs(lage.v));
    }
    return bester;
}
/**
 * Spalte c des Turms, in dem die Kachel liegt — oder null. Die Spalten
 * zaehlen von der Achse weg: c = 0 ist die Schale am Tunnelrand.
 */
export function turmSpalte(px, py) {
    for (const turm of TUERME) {
        const lage = lageZurAchse(px, py, turm.achse);
        if (!lage)
            continue;
        const d = Math.floor(lage.d);
        if (d < TURM.torZeile || d > TURM.tuerZeile)
            continue;
        const c = Math.floor(turm.seite * lage.v - TURM.abstandVonAchse);
        if (c >= 0 && c < TURM.breite)
            return c;
    }
    return null;
}
/** Liegt die Kachel in einer Imbissbude? */
export function imImbiss(px, py) {
    for (const achse of IMBISSE) {
        const lage = lageZurAchse(px, py, achse);
        if (!lage)
            continue;
        const d = Math.floor(lage.d);
        if (d >= IMBISS_VON && d < IMBISS_BIS && Math.abs(lage.v) <= IMBISS_HALBBREITE)
            return true;
    }
    return false;
}
//# sourceMappingURL=zugaenge.js.map